import r from '../core';

export default {
  getQuestionsByTopic(options, callback) {
    options.params = options.params || {};
    options.url = API_URL + 'community/topics/' + options.topic;
    options.params.per_page = options.per_page ? options.per_page : 10;
    options.params.current_page = options.current_page;
    return r.get(options, callback);
  },
  getQuestions(options, callback) {
    options.url = API_URL + 'community/questions';
    options.params = options.params || {};
    options.params.per_page = options.per_page ? options.per_page : 10;
    options.params.current_page = options.current_page;
    return r.get(options, callback);
  },

  getFeaturedQuestions(options, callback) {
    options.url = API_URL + 'community/questions/featured';
    options.params = options.params || {};
    options.params.per_page = options.per_page ? options.per_page : 10;
    options.params.current_page = options.current_page;
    return r.get(options, callback);
  },

  getTopicInfo(options, callback) {
    options.url = API_URL + 'community/topics/' + options.topic + '/info';
    return r.get(options, callback);
  },

  getQuestionReactions(options, callback) {
    options.url = API_URL + 'community/questions/' + options.question_id + '/reactions';
    return r.get(options, callback);
  },

  getQuestionComments(options, callback) {
    options.url = API_URL + 'community/questions/' + options.question_id + '/comments';
    options.params = {};
    options.params.per_page = options.per_page ? options.per_page : 10;
    options.params.current_page = options.current_page;
    return r.get(options, callback);
  },

  deleteQuestion(options = {}, callback) {
    options.url = API_URL + 'community/questions/' + options.question_id;
    return r.delete(options, callback);
  },

  updateQuestion(options = {}, callback) {
    options.url = API_URL + 'community/questions/' + options.question_id;
    return r.put(options, callback);
  },

  getCommentVote(options, callback) {
    options.url = API_URL + 'community/questions/' + options.question_id + '/comments/' + options.comment_id + '/upvote';
    return r.get(options, callback);
  },

  getCommentDownVote(options, callback) {
    options.url = API_URL + 'community/questions/' + options.question_id + '/comments/' + options.comment_id + '/downvote';
    return r.get(options, callback);
  },

  getCommentReplies(options, callback) {
    options.url = API_URL + 'community/questions/' + options.question_id + '/comments/' + options.comment_id + '/replies?order=latest';
    return r.get(options, callback);
  },

  postQuestionReaction(options, callback) {
    options.url = API_URL + 'community/questions/' + options.question_id + '/reactions';
    return r.post(options, callback);
  },

  postQuestionComment(options, callback) {
    options.url = API_URL + 'community/questions/' + options.question_id + '/comments';
    return r.post(options, callback);
  },

  postCommentComment(options, callback) {
    options.url = API_URL + 'community/questions/' + options.question_id + '/comments';
    return r.post(options, callback);
  },

  postFlag(options, callback) {
    switch (options.type) {
      case 'question':
        options.url = API_URL + 'community/questions/' + options.question_id + '/flag';
        break;
      case 'comment':
        options.url = API_URL + 'community/questions/' + options.question_id + '/comments/' + options.comment_id + '/flag';
        break;
      default: break;
    }
    return r.post(options, callback);
  },

  postNewQuestion(options, callback) {
    options.url = API_URL + 'community/questions';
    return r.post(options, callback);
  },

  deleteComment(options, callback) {
    options.url = API_URL + 'community/questions/' + options.question_id + '/comments/' + options.comment_id;
    r.delete(options, callback);
  },
};
